import Repository from '@/repositories/marketing'
const productResource = '/products'

export default {
  /**
   * @use Product catalog index UI
   */
  fetch (config) {
    return Repository.get(`${productResource}.json`, config)
  },
  import (payload, config) {
    return Repository.post(`${productResource}/import.json`, payload, config)
  },
  show (productId, config) {
    return Repository.get(`${productResource}/${productId}.json`, config)
  },
  update (productId, data, config) {
    return Repository.put(`${productResource}/${productId}.json`, data, config)
  },
  onFilter (config) {
    return Repository.get(`${productResource}/search.json`, config)
  },
  getAllBrands (config) {
    return Repository.get(`${productResource}/get_all_brands.json`, config)
  },
}
